export default __webpack_public_path__ + "media/images/ad_landing_page/Wells-b4888f2d66baf2dfd1c528ebbb00dc1d.png";